import React, { useEffect, useRef, useState } from "react";
import {
    generalIcons,
    validatorListIcons,
    vanarExplorerUrl,
} from "../utils/constants";
import {
    copyToClipBoard,
    formatNumber,
    formatScientificNumber,
    getTruncatedAddress,
    getTruncatedTrx,
    isScientificNotation,
} from "../utils/helper";
import { handleTrxHistoryBtn } from "../utils/buttons.helper";
import ClipLoaderComponent from "./loader/ClipLoaderComponent";

export default function TransactionList({
    userTrxHistory,
    userDelegators,
    handleSort,
    hasMore,
    isFetchingTrx,
    setIsLoadingMore,
    isLoadingMore,
    setHasMore,
    lastClaimDoc,lastTransactionDoc,
    fetchUserTransactions
}) {
    const [copiedId, setCopiedId] = useState(null);
    const [fromCopiedId, setFromCopiedId] = useState(null);
    const [toolTipId, setToolTipId] = useState(null);
    const [isShowToolTip, setIsShowToolTip] = useState(false);
    const validatorNames = userDelegators?.map((delegator) => ({
        name: delegator?.name,
        contract_address: delegator?.contract_address,
    }));
    useEffect(() => {
        if (copiedId !== null || fromCopiedId !== null) {
            const timer = setTimeout(() => {
                setCopiedId(null);
                setFromCopiedId(null);
            }, 2000);

            return () => clearTimeout(timer); // Clear timeout on cleanup
        }
    }, [copiedId, fromCopiedId]);

    const tableDivRef = useRef(null); // Create a ref for the main table div

    const handleTrxRedirect = (trxId) => {
        window.open(vanarExplorerUrl + "/tx/" + trxId, "_black");
    };

    const [transactions, setTransactions] = useState([]);
    const [page, setPage] = useState(1);
    const pageSize = 10; // Set how many transactions per scroll

    useEffect(() => {
        setTransactions(userTrxHistory?.slice(0, page * pageSize));
    }, [userTrxHistory]);

    useEffect(() => {
        if (page > 1) {
            fetchTransactions();
            // fetchUserTransactions(lastTransactionDoc, lastClaimDoc, true)
        }
    }, [page]);

    const fetchTransactions = () => {
        const newTransactions = transactions?.slice(
            (page - 1) * pageSize,
            page * pageSize,
        );

        if (page * pageSize > userTrxHistory?.length) {
            setTransactions((prev) => [...prev, ...newTransactions]);
            setHasMore(false);
        } else {
            setTransactions((prev) => [...prev, ...newTransactions]);
        }
    };

    const handleScroll = () => {
        const div = tableDivRef.current;

        if (div) {
            if (div.scrollHeight - 300 < div.scrollTop + div.clientHeight) {
                setIsLoadingMore(true);
            }
        }
    };

    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    useEffect(() => {
        const div = tableDivRef.current;
        if (div) {
            const debouncedScroll = debounce(handleScroll, 200);
            div.addEventListener("scroll", debouncedScroll);
        }

        return () => {
            if (div) {
                div.removeEventListener("scroll", debounce(handleScroll, 200));
            }
        };
    }, []);

    useEffect(() => {
        if (
            isLoadingMore === true &&
            transactions?.length !== userTrxHistory?.length
        ) {
            setTimeout(() => {
                setPage((prevPage) => prevPage + 1);
                setIsLoadingMore(false);
            }, 1000);
        }
    }, [isLoadingMore]);


    const handleWalletClick = (address) => {
        window.open(vanarExplorerUrl + "/address/" + address, "_blank");
    };

    return (
        <div
            ref={tableDivRef}
            className="relative max-h-[1080px] overflow-auto rounded-3xl border-[1.5px] border-primaryWhite/[0.03] bg-[#121212]"
        >
            <table className="w-full text-left">
                <thead className="border-b border-primaryWhite/[0.04] bg-black/[0.31]">
                    <tr>
                        <th className="px-7 py-9">
                            <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] cursor-pointer whitespace-nowrap">
                                Name
                                <span className="w-3 h-3 *:w-full *:h-full">
                                    {/* {getSortIcon("name")} */}
                                </span>
                            </div>
                        </th>
                        <th className="px-7 py-9">
                            <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap">
                                Txn Hash
                            </div>
                        </th>
                        <th className="px-7 py-9">
                            <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap">
                                From
                            </div>
                        </th>
                        <th className="px-7 py-3">
                            <span className="sr-only"></span>
                        </th>
                        <th className="px-7 py-9">
                            <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap">
                                To
                            </div>
                        </th>
                        <th className="px-7 py-9">
                            <div
                                className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap"
                                onClick={() => handleSort("type")}
                            >
                                Method
                                <span className="w-3 h-3 *:w-full *:h-full hover:text-white">
                                    {validatorListIcons.arrow}
                                </span>
                            </div>
                        </th>
                        <th className="px-7 py-9">
                            <div
                                className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap"
                                onClick={() => handleSort("value")}
                            >
                                $VANRY
                                <span className="w-3 h-3 *:w-full *:h-full hover:text-white">
                                    {validatorListIcons.arrow}
                                </span>
                            </div>
                        </th>
                        <th className="px-7 py-9">
                            <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap">
                                Validator Address
                            </div>
                        </th>
                        <th className="px-7 py-9">
                            <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] whitespace-nowrap">
                                Action/Status
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {isFetchingTrx && (
                        <tr className="border-b border-white/[0.03]">
                            <td
                                className="px-7 py-9"
                                colSpan="9"
                            >
                                <ClipLoaderComponent
                                    size={40}
                                    customClass={"justify-center"}
                                />
                            </td>
                        </tr>
                    )}

                    {!isFetchingTrx && transactions.length === 0 && (
                        <tr className="border-b border-white/[0.03]">
                            <td
                                className="px-7 py-12"
                                colSpan="9"
                            >
                                <div className="text-sm leading-4 font-normal whitespace-nowrap flex justify-center items-center gap-3">
                                    No Transaction Found
                                </div>
                            </td>
                        </tr>
                    )}

                    {!isFetchingTrx &&
                        transactions.map((transaction, index) => (
                            <tr
                                key={transaction?.id}
                                className="border-b border-white/[0.03] hover:bg-[#1A1A1A80]"
                            >
                                <td className="px-7 pt-6 pb-8">
                                    <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-primaryWhite whitespace-nowrap">
                                        {validatorNames?.find(
                                            (data) =>
                                                data?.contract_address ===
                                                transaction?.to,
                                        )?.name || "N/A"}
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div
                                        onClick={() =>
                                            handleTrxRedirect(transaction?.id)
                                        }
                                        className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-tagcolor underline whitespace-nowrap cursor-pointer"
                                    >
                                        {getTruncatedTrx(transaction?.id)}
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div className="text-sm leading-4 font-normal whitespace-nowrap flex items-center gap-3">
                                        <div className="flex items-center justify-center w-[30px] h-[30px]">
                                            {/* <img
                                                src={`${process.env.REACT_APP_S3_ASSETS_URL}chainFlowIcon.png`}
                                                alt=""
                                                className="object-cover"
                                            /> */}
                                        </div>
                                        <span
                                            className="hover:underline hover:cursor-pointer"
                                            onClick={() =>
                                                handleWalletClick(
                                                    transaction?.from,
                                                )
                                            }
                                        >
                                            {getTruncatedAddress(
                                                transaction?.from,
                                            )}
                                        </span>
                                        <span
                                            className="w-5 h-5 *:w-full *:h-full cursor-pointer"
                                            onClick={() =>
                                                copyToClipBoard(
                                                    transaction?.from,
                                                    setFromCopiedId(index),
                                                )
                                            }
                                        >
                                            {fromCopiedId === index
                                                ? generalIcons.copied
                                                : generalIcons.copyAddress}
                                        </span>
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div className="flex items-center justify-center w-[30px] h-[30px] *:w-full *:h-full">
                                        {validatorListIcons.rightArrow}
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div className="text-sm leading-4 font-normal whitespace-nowrap flex items-center gap-3">
                                        <div className="flex items-center justify-center w-[30px] h-[30px]">
                                            {/* <img
                                                src={`${process.env.REACT_APP_S3_ASSETS_URL}chainFlowIcon.png`}
                                                alt=""
                                                className="object-cover"
                                            /> */}
                                        </div>
                                        <span
                                            className="hover:underline hover:cursor-pointer"
                                            onClick={() =>
                                                handleWalletClick(
                                                    transaction?.to,
                                                )
                                            }
                                        >
                                            {getTruncatedAddress(
                                                transaction?.to,
                                            )}
                                        </span>
                                        <span
                                            className="w-5 h-5 *:w-full *:h-full cursor-pointer"
                                            onClick={() => {
                                                copyToClipBoard(
                                                    transaction?.to,
                                                );
                                                setCopiedId(index);
                                            }}
                                        >
                                            {copiedId === index
                                                ? generalIcons.copied
                                                : generalIcons.copyAddress}
                                            {/* {generalIcons.copied} */}
                                        </span>
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-primaryWhite whitespace-nowrap">
                                        {transaction?.type?.toUpperCase()}
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-primaryWhite whitespace-nowrap">
                                        {/* {formatNumber((transaction?.value)?.toString())} */}
                                        <div className="flex items-center">
                                            <span className="pr-1">
                                                {isScientificNotation(transaction?.value)
                                                    ? formatNumber(formatScientificNumber(transaction?.value, 18))
                                                    : formatNumber(
                                                        transaction?.value > 10 ?
                                                            transaction?.value :
                                                            transaction?.value?.toString()
                                                    )}
                                            </span>
                                            {transaction?.type?.toLowerCase() === "claim reward" && <div
                                                className="relative md:w-[18px] md:h-[18px] text-[#FFF5F566]/35 hover:text-white/80"
                                                id={transaction?.value}
                                                onMouseEnter={() => {
                                                    setIsShowToolTip(true)
                                                    setToolTipId(index)
                                                }
                                                }
                                                onMouseLeave={() =>
                                                    setIsShowToolTip(false)
                                                }
                                            >
                                                {isShowToolTip && toolTipId === index && (
                                                    <div className="absolute right-[-6px] tooltip_custom bg-white text-[#06080C] rounded-[8px] py-[6px] px-4 w-max">
                                                        <p className="text-[10px] lg:text-[14px] font-medium break-words">
                                                            {transaction?.value >
                                                                1
                                                                ? transaction?.value?.toLocaleString(
                                                                    "en-US",
                                                                )
                                                                : isScientificNotation(transaction?.value)
                                                                    ? formatScientificNumber(transaction?.value, 18)
                                                                    : transaction?.value}
                                                        </p>
                                                    </div>
                                                )}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="22"
                                                    viewBox="0 0 22 22"
                                                    fill="none"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                    }}
                                                >
                                                    <path
                                                        d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                                                        stroke="currentColor"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M11 7.33337V11.9167"
                                                        stroke="currentColor"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M10.9951 14.6666H11.0034"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>}
                                        </div>
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8">
                                    <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-primaryWhite whitespace-nowrap">
                                        <span
                                            className="hover:underline hover:cursor-pointer"
                                            onClick={() =>
                                                handleWalletClick(
                                                    transaction?.to,
                                                )
                                            }
                                        >
                                            {getTruncatedAddress(
                                                transaction?.to,
                                            )}
                                        </span>
                                    </div>
                                </td>
                                <td className="px-7 pt-6 pb-8 text-center">
                                    {handleTrxHistoryBtn(
                                        transaction?.type?.toLowerCase(),
                                        transaction?.date,
                                        userDelegators,
                                        transaction?.to,
                                        transaction?.status?.toLowerCase(),
                                        transaction?.value,
                                        transaction?.claimed,
                                        transaction?.id,
                                    )}
                                </td>
                            </tr>
                        ))}

                    {isLoadingMore && hasMore && transactions?.length > 10 && (
                        <tr className="border-b border-white/[0.03]">
                            <td
                                className="px-7 py-9"
                                colSpan="9"
                            >
                                <ClipLoaderComponent
                                    size={40}
                                    customClass={"justify-center"}
                                />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
